import React, { Component } from 'react';
import { Modal as BModal } from 'react-bootstrap';
import { Button, Select, Input, Icon, SelectSearch, Table } from "../../../../components";
import { Globals } from "../../../../utils";
import axios from "../../../../utils/axios";

class ModalCommission extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            type: '', // 1 = fecha de pagos, 2 = categoria, 3 = productos

            user_type: 2, // 2: Vendedor, 1: Gerente

            // Para fecha de pagos
            from_days: '',
            to_days: '',
            percentage_date: '',

            // Para categorias
            selected_category: null,
            percentage_category: '',

            // Para productos
            selected_product: null,
            percentage_product: '',

            details: [],

            categories: [],
            products: [],
            loading: false
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.show && !prevProps.show) {
            this.loadSelects();
            if (this.props.commission) {
                const details = this.props.commission.details || [];
                this.setState({
                    step: 2,
                    type: String(this.props.commission.type),
                    details: details,

                    user_type: 2,
                    from_days: '',
                    to_days: '',
                    percentage_date: '',
                    selected_category: null,
                    percentage_category: '',
                    selected_product: null,
                    percentage_product: '',
                });
            } else {
                this.setState({
                    step: 1,
                    type: '',
                    details: [],

                    user_type: 2,
                    from_days: '',
                    to_days: '',
                    percentage_date: '',
                    selected_category: null,
                    percentage_category: '',
                    selected_product: null,
                    percentage_product: '',
                });
            }
        }
    }

    loadSelects = async () => {
        this.setState({ loading: true });
        try {
            const res = await axios.post('admin/discounts/get-selects', { user_id: this.props.user_id });
            if (res.data) {
                this.setState({
                    products: res.data.products || [],
                    categories: res.data.categories || [],
                    loading: false
                });
            }
        } catch (error) {
            console.error('Error fetching selects:', error);
            this.setState({ loading: false });
        }
    }

    getProductInfo = (product_id) => {
        const found = this.state.products.find(p => p.id === product_id);
        return found || { name: 'Cargando...', code: '' };
    }

    getCategoryInfo = (category_id) => {
        const found = this.state.categories.find(c => c.id === category_id);
        return found || { name: 'Cargando...' };
    }

    handleAddDetail = () => {
        const { type, user_type, from_days, to_days, percentage_date, selected_category, percentage_category, selected_product, percentage_product, details } = this.state;

        let newDetail = {
            user_type: parseInt(user_type),
        };

        if (type === '1') { // Fecha de pagos
            if (from_days === '') return Globals.showError('Ingrese el periodo "Desde"');
            if (parseInt(from_days) < 0) return Globals.showError('El periodo "Desde" no puede ser negativo');
            if (to_days === '') return Globals.showError('Ingrese el periodo "Hasta"');
            if (parseInt(to_days) < 0) return Globals.showError('El periodo "Hasta" no puede ser negativo');
            if (parseInt(from_days) > parseInt(to_days)) return Globals.showError('El periodo "Desde" no puede ser mayor al periodo "Hasta"');
            if (!percentage_date) return Globals.showError('Ingrese el % de comisión');

            const newFrom = parseInt(from_days);
            const newTo = parseInt(to_days);

            let existingDetails = [];
            if (this.props.sellers_commissions) {
                existingDetails = existingDetails.concat(this.props.sellers_commissions);
            }
            if (this.props.managers_commissions) {
                existingDetails = existingDetails.concat(this.props.managers_commissions);
            }
            if (this.props.commission) {
                existingDetails = existingDetails.filter(d => d.commission?.id !== this.props.commission.id);
            }

            const checkOverlap = (list) => list.some(d => {
                const isType1 = d.commission ? String(d.commission.type) === '1' : true;
                return parseInt(d.user_type) === parseInt(user_type) &&
                    isType1 &&
                    d.from_days !== null && d.to_days !== null &&
                    (newFrom <= parseInt(d.to_days) && parseInt(d.from_days) <= newTo);
            });

            if (checkOverlap(details) || checkOverlap(existingDetails)) {
                return Globals.showError('Ya existe una comisión agregada que se solapa con este rango para este tipo de usuario');
            }

            newDetail.from_days = parseInt(from_days);
            newDetail.to_days = parseInt(to_days);
            newDetail.percentage = parseFloat(percentage_date);

        } else if (type === '2') { // Categorias
            if (!selected_category) return Globals.showError('Seleccione una categoría');
            if (!percentage_category) return Globals.showError('Ingrese el % de comisión');

            const category_id = selected_category.value;
            const exists = details.some(d => d.user_type === parseInt(user_type) && d.category_id === category_id);
            if (exists) return Globals.showError('Ya existe una comisión agregada para esta categoría y tipo de usuario');

            newDetail.category_id = category_id;
            newDetail.percentage = parseFloat(percentage_category);

        } else if (type === '3') { // Productos
            if (!selected_product) return Globals.showError('Seleccione un producto');
            if (!percentage_product) return Globals.showError('Ingrese el % de comisión');

            const product = selected_product.product;
            const exists = details.some(d => d.user_type === parseInt(user_type) && d.product_id === product.id);
            if (exists) return Globals.showError('Ya existe una comisión agregada para este producto y tipo de usuario');

            newDetail.product_id = product.id;
            newDetail.percentage = parseFloat(percentage_product);
        }

        this.setState({
            details: [...details, newDetail],
            from_days: '',
            to_days: '',
            percentage_date: '',
            selected_category: null,
            percentage_category: '',
            selected_product: null,
            percentage_product: '',
        });
    }

    handleChangeUserType = (newType) => {
        if (this.state.user_type === newType) return;

        if (this.state.details.length > 0) {
            const targetName = newType === 1 ? 'Gerente' : 'Vendedor';
            Globals.confirm(`Si selecciona ${targetName}, los registros existentes cambiarán a ${targetName}. ¿Desea continuar?`, () => {
                const updatedDetails = this.state.details.map(d => ({ ...d, user_type: newType }));
                this.setState({ user_type: newType, details: updatedDetails });
            });
        } else {
            this.setState({ user_type: newType });
        }
    }

    handleNext = () => {
        if (!this.state.type) {
            return Globals.showError('Seleccione un tipo de comisión');
        }
        this.setState({ step: 2 });
    }

    handleSave = async () => {
        const { type, details } = this.state;

        if (details.length === 0) {
            return Globals.showError('Debe agregar al menos un registro de comisión a la lista');
        }

        Globals.setLoading();
        try {
            const payload = {
                id: this.props.commission ? this.props.commission.id : null,
                user_id: this.props.user_id,
                type: parseInt(type),
                is_active: 1,
                details: details.map(d => ({
                    user_type: d.user_type,
                    percentage: d.percentage,
                    from_days: d.from_days !== undefined ? d.from_days : null,
                    to_days: d.to_days !== undefined ? d.to_days : null,
                    category_id: d.category_id || null,
                    product_id: d.product_id || null,
                }))
            };

            const res = await axios.post('admin/commissions/create-update', payload);

            if (res.data.result) {
                Globals.showSuccess("Comisión guardada exitosamente");
                this.props.onSuccess();
            } else {
                Globals.showError(res.data.error || 'Ocurrió un error al guardar');
            }
        } catch (error) {
            console.log(error);
            const msg = error.response?.data?.error || 'Ocurrió un error inesperado';
            Globals.showError(msg);
        }
        Globals.quitLoading();
    }

    render() {
        const { show, onHide, commissionTypes } = this.props;
        const { step, type, details, products, categories, user_type } = this.state;

        const isDate = type === '1';
        const isCategory = type === '2';
        const isProduct = type === '3';

        const typeTitle = isDate ? 'por fecha de pagos' : isCategory ? 'por categoría' : isProduct ? 'por producto' : '';

        return (
            <BModal show={show} onHide={onHide} size="lg" centered>
                <BModal.Header closeButton style={{ borderBottom: 'none', paddingBottom: 0 }}>
                    <BModal.Title style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>
                        {step === 2 && !this.props.commission && (
                            <span
                                style={{ cursor: 'pointer', marginRight: '10px' }}
                                onClick={() => this.setState({ step: 1 })}
                            >
                                <Icon name="arrow-left" />
                            </span>
                        )}
                        {this.props.commission
                            ? `Editar comisión ${typeTitle}`
                            : (step === 1 ? 'Nueva comisión' : `Crear comisión ${typeTitle}`)
                        }
                    </BModal.Title>
                </BModal.Header>
                <BModal.Body style={{ paddingTop: 0 }}>
                    <div className="d-flex justify-content-center align-items-center mb-5 mt-2">
                        <span style={{ color: step === 1 ? '#007bff' : '#ccc', fontWeight: step === 1 ? 'bold' : 'normal' }}>
                            Tipo de comisión
                        </span>
                        <div style={{ height: '2px', width: '80px', background: '#ccc', margin: '0 15px' }}></div>
                        <span style={{ color: step === 2 ? '#007bff' : '#ccc', fontWeight: step === 2 ? 'bold' : 'normal' }}>
                            Comisiones
                        </span>
                    </div>

                    {step === 1 && (
                        <div style={{ paddingBottom: '30px' }}>
                            <p style={{ fontWeight: 'bold' }}>Seleccione el tipo de comisión</p>
                            <Select
                                color=""
                                className="material"
                                labelClass="material"
                                options={commissionTypes.filter(t => t.value !== '')}
                                value={type}
                                onChange={(e) => this.setState({ type: e.target.value })}
                            />
                            <div className="d-flex justify-content-center mt-5">
                                <Button
                                    color=" "
                                    className="primary"
                                    onClick={this.handleNext}
                                    style={{ width: '150px' }}
                                >
                                    Siguiente
                                </Button>
                            </div>
                        </div>
                    )}

                    {step === 2 && (
                        <div>
                            <div className="mb-4">
                                <label className="d-block mb-2" style={{ fontWeight: 'bold', color: '#333' }}>Tipo de usuario</label>
                                <div className="d-flex align-items-center" style={{ gap: '20px' }}>
                                    <div
                                        className="d-flex align-items-center"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => this.handleChangeUserType(2)}
                                    >
                                        <span style={{
                                            width: '20px',
                                            height: '20px',
                                            borderRadius: '50%',
                                            border: '2px solid #ccc',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '8px',
                                            backgroundColor: user_type === 2 ? '#2ecc71' : 'transparent',
                                            borderColor: user_type === 2 ? '#2ecc71' : '#ccc'
                                        }}>
                                        </span>
                                        <span>Vendedor</span>
                                    </div>
                                    <div
                                        className="d-flex align-items-center"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => this.handleChangeUserType(1)}
                                    >
                                        <span style={{
                                            width: '20px',
                                            height: '20px',
                                            borderRadius: '50%',
                                            border: '2px solid #ccc',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '8px',
                                            backgroundColor: user_type === 1 ? '#2ecc71' : 'transparent',
                                            borderColor: user_type === 1 ? '#2ecc71' : '#ccc'
                                        }}>
                                        </span>
                                        <span>Gerente</span>
                                    </div>
                                </div>
                            </div>

                            {isDate && (
                                <div className="row mb-3 align-items-end">
                                    <div className="col-md-6">
                                        <label className="d-block mb-2" style={{ fontWeight: 'bold', color: '#333' }}>Periodo de pago</label>
                                        <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                            <div style={{ width: '100px' }}>
                                                <Input
                                                    color=""
                                                    className="material"
                                                    labelClass="material"
                                                    label="Desde (Días)"
                                                    type="number"
                                                    min="0"
                                                    value={this.state.from_days}
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        if (val === '' || parseInt(val) >= 0) {
                                                            this.setState({ from_days: val });
                                                        }
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (['.', ',', 'e', 'E', '-', '+'].includes(e.key)) e.preventDefault();
                                                    }}
                                                />
                                            </div>
                                            <div style={{ width: '100px' }}>
                                                <Input
                                                    color=""
                                                    className="material"
                                                    labelClass="material"
                                                    label="Hasta (Días)"
                                                    type="number"
                                                    min="0"
                                                    value={this.state.to_days}
                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        if (val === '' || parseInt(val) >= 0) {
                                                            this.setState({ to_days: val });
                                                        }
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (['.', ',', 'e', 'E', '-', '+'].includes(e.key)) e.preventDefault();
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <Input
                                            color=""
                                            className="material"
                                            labelClass="material"
                                            label="Comisión (%)"
                                            placeholder="Ejemplo: 5,0"
                                            type="number"
                                            min="0"
                                            value={this.state.percentage_date}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === '' || parseFloat(val) >= 0) {
                                                    this.setState({ percentage_date: val });
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            )}

                            {isCategory && (
                                <div className="row mb-3 align-items-end">
                                    <div className="col-md-6">
                                        <label className="d-block mb-2" style={{ fontWeight: 'bold', color: '#333' }}>Categorías a las que aplica</label>
                                        <SelectSearch
                                            placeholder="Buscar categoría"
                                            options={categories.map((c) => ({
                                                value: c.id,
                                                label: c.name
                                            }))}
                                            value={this.state.selected_category}
                                            onChange={(data) => this.setState({ selected_category: data })}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <Input
                                            color=""
                                            className="material"
                                            labelClass="material"
                                            label="Comisión (%)"
                                            placeholder="Ejemplo: 5,0"
                                            type="number"
                                            min="0"
                                            value={this.state.percentage_category}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === '' || parseFloat(val) >= 0) {
                                                    this.setState({ percentage_category: val });
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            )}

                            {isProduct && (
                                <div className="row mb-3 align-items-end">
                                    <div className="col-md-6">
                                        <label className="d-block mb-2" style={{ fontWeight: 'bold', color: '#333' }}>Productos a los que aplica</label>
                                        <SelectSearch
                                            placeholder="Buscar producto por nombre"
                                            options={products.map((p) => ({
                                                value: p.id,
                                                label: `${p.name} (${p.code})`,
                                                product: p
                                            }))}
                                            value={this.state.selected_product}
                                            onChange={(data) => this.setState({ selected_product: data })}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <Input
                                            color=""
                                            className="material"
                                            labelClass="material"
                                            label="Comisión (%)"
                                            placeholder="Ejemplo: 5,0"
                                            type="number"
                                            min="0"
                                            value={this.state.percentage_product}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === '' || parseFloat(val) >= 0) {
                                                    this.setState({ percentage_product: val });
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="d-flex justify-content-center mb-4 mt-4">
                                <Button
                                    color=" "
                                    className="primary d-flex align-items-center justify-content-center"
                                    style={{ gap: '5px' }}
                                    onClick={this.handleAddDetail}
                                    disabled={(isCategory || isProduct) && details.length > 0}
                                >
                                    <Icon name="plus" /> Agregar
                                </Button>
                            </div>

                            <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                {details.length > 0 ? (
                                    <Table
                                        header={
                                            isDate ? ['Tipo de usuario', 'Desde', 'Hasta', 'Comisión %', ''] :
                                                isCategory ? ['Tipo de usuario', 'Comisión %', 'Categoría', ''] :
                                                    ['Tipo de usuario', 'Comisión %', 'Producto', 'Código', '']
                                        }
                                        data={details.length}
                                        headerStyle={{ background: '#1c3454', color: '#fff' }}
                                    >
                                        {details.map((detail, index) => {
                                            const uTypeStr = detail.user_type === 1 ? 'Gerente' : 'Vendedor';
                                            return (
                                                <tr key={index}>
                                                    <td>{uTypeStr}</td>

                                                    {isDate && <td>{detail.from_days}</td>}
                                                    {isDate && <td>{detail.to_days}</td>}

                                                    {!isDate && <td>{detail.percentage}</td>}

                                                    {isDate && <td>{detail.percentage}</td>}

                                                    {isCategory && <td>{this.getCategoryInfo(detail.category_id).name}</td>}

                                                    {isProduct && <td>{this.getProductInfo(detail.product_id).name}</td>}
                                                    {isProduct && <td>{this.getProductInfo(detail.product_id).code}</td>}

                                                    <td style={{ textAlign: 'right' }}>
                                                        <span
                                                            style={{ cursor: 'pointer', color: '#dc3545' }}
                                                            onClick={() => {
                                                                const updatedDetails = [...details];
                                                                updatedDetails.splice(index, 1);
                                                                this.setState({ details: updatedDetails });
                                                            }}
                                                        >
                                                            <Icon name="trash" />
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </Table>
                                ) : (
                                    <div className="alert alert-light text-center" style={{ border: '1px solid #f1f1f1', backgroundColor: '#f9f9f9', padding: '30px', color: '#aaa' }}>
                                        No hay detalles de comisiones agregados.
                                    </div>
                                )}
                            </div>

                            <div className="d-flex justify-content-center mt-5 mb-2">
                                <Button
                                    color=" "
                                    className="primary"
                                    onClick={this.handleSave}
                                    style={{ width: '150px' }}
                                >
                                    Guardar
                                </Button>
                            </div>
                        </div>
                    )}
                </BModal.Body>
            </BModal>
        );
    }
}

export default ModalCommission;
